<template>
  <div>
    <ProductCard
      v-if="product"
      :key="`product-${product.id}`"
      data-test-id="product-item"
      :product="product"
      :show-price-reduction="isInActiveSalePeriod"
      :is-carousel-item="isCarouselItem"
      @click:product="$emit('click:product', product)"
    >
      <template #header-badge>
        <ProductCardBadges :product="product" />
      </template>
    </ProductCard>
  </div>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'

defineProps<{
  index?: number
  width?: string
  fetching?: boolean
  product?: Product
  isCarouselItem?: boolean
}>()

defineEmits<{ 'click:product': [value: Product] }>()

const { isActiveSalePeriod: isInActiveSalePeriod } = useSmartShopConfiguration()
</script>
